export const ArrowRightIcon = () => (
  <svg className="arrow-right-icon" viewBox="0 0 24 25" role="img">
    <title>Arrow Right</title>
    <path d="M11.7893 4.50543L11.0822 5.21253C10.9148 5.37989 10.9148 5.65125 11.0822 5.81864L16.6226 11.359H4.42857C4.19189 11.359 4 11.5508 4 11.7875V12.7875C4 13.0242 4.19189 13.2161 4.42857 13.2161H16.6226L11.0822 18.7564C10.9148 18.9238 10.9148 19.1952 11.0822 19.3626L11.7893 20.0697C11.9567 20.237 12.228 20.237 12.3954 20.0697L19.8745 12.5906C20.0418 12.4232 20.0418 12.1519 19.8745 11.9845L12.3954 4.50543C12.228 4.33803 11.9567 4.33803 11.7893 4.50543Z" />
  </svg>
)
